<template>
  <div class="record">
    <div class="record-list">
      <div class="record-card" v-for="(item, index) in history" @click="handleLiveClick(item.news_id)" :key="index">
        <div class="card-tag" :class="[
          item.type === 1 ? 'tag-high' :
            item.type === 2 ? 'tag-middle' : 'tag-low'
        ]">
          {{ item.type === 1 ? '高级课程' : item.type === 2 ? '中级课程' : '初级课程' }}
        </div>
        <div class="card-content">
          <div class="card-info">
            <div class="name">{{ item.name }}</div>
            <p class="card-time">{{ item.study_at }}学习</p>
            <p class="card-desc">{{ item.remark }}</p>
          </div>
          <div class="card-cover">
            <img :src="item.cover || defaultImg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 🔥 核心：iframe 直播容器（默认隐藏，点击直播中时显示） -->
    <div v-if="showLiveIframe" class="live-iframe-container">
      <div class="iframe-header">
        <h3>{{ currentLiveTitle }}</h3>
        <button class="close-btn" @click="closeLiveIframe">× 关闭</button>
      </div>
      <iframe :src="currentLiveUrl" frameborder="0" class="live-iframe" allowfullscreen></iframe>
    </div>
    <div class="page" v-if="total > 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
        :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  newsHistory,
  newsInfo
} from '@/api/api'

export default {
  name: "index",
  data() {
    return {
      defaultImg: require('@/assets/defaultImg.png'),
      history: [],
      page: 1,
      limit: 10,
      total: 0,
      // 控制iframe显示/隐藏
      showLiveIframe: false,
      // 当前直播的地址（动态绑定）
      currentLiveUrl: "",
      // 当前直播的标题（可选，用于iframe头部显示）
      currentLiveTitle: "",
    }
  },
  mounted() {
    this.newsHistory()
  },
  methods: {
    handleSizeChange(val) {
      this.limit = val
      this.newsHistory()
    },
    handleCurrentChange(val) {
      this.page = val
      this.newsHistory()
    },
    generateRandomString(length = 32, charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') {
      // 1. 获取当前时间戳（毫秒级）
      const timestamp = Date.now().toString();

      // 2. 生成随机数字和字符串（补充材料）
      const randomPart1 = Math.random().toString(36).substring(2, 10); // 随机字母数字
      const randomPart2 = Math.random().toString(10).substring(2, 8); // 纯随机数字
      const randomPart3 = String.fromCharCode(
        65 + Math.floor(Math.random() * 26),
        97 + Math.floor(Math.random() * 26),
        48 + Math.floor(Math.random() * 10)
      ); // 随机大小写字母 + 数字各一个

      // 3. 合并所有素材
      let combined = timestamp + randomPart1 + randomPart2 + randomPart3;

      // 4. 如果合并后的长度不足目标长度，继续补充随机字符
      while (combined.length < length) {
        combined += Math.random().toString(36).substring(2, 10);
      }

      // 5. 截取所需长度
      combined = combined.substring(0, length);

      // 6. 打乱顺序（Fisher-Yates 洗牌算法）
      const arr = combined.split('');
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }

      // 7. 可选：使用自定义字符集过滤（如果传入自定义字符集）
      if (charset !== 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') {
        // 如果自定义字符集，从结果中筛选可用字符，不足则补充
        let filtered = arr.filter(ch => charset.includes(ch)).join('');
        while (filtered.length < length) {
          const extra = generateRandomString(length - filtered.length, charset);
          filtered += extra;
        }
        return filtered.substring(0, length);
      }

      return arr.join('');
    },
    // 直播详情
    handleLiveClick(id) {
      newsInfo(id).then(res => {

        if (res.data.url.startsWith("https://")) {
          this.currentLiveUrl = `https://ow365.cn/?i=37451&ssl=0&n=5&htool=1&draw=3&fname=${this.generateRandomString(10)}&furl=${res.data.url}`;
        } else if (res.data.url.startsWith("http://")) {
          this.currentLiveUrl = `https://ow365.cn/?i=37451&ssl=0&n=5&htool=1&draw=3&fname=${this.generateRandomString(10)}&furl=${res.data.url}`;
        }
        console.log('open4', this.currentLiveUrl);

        this.currentLiveTitle = res.data.name;
        this.showLiveIframe = true;
        // 页面滚动到iframe位置（可选，优化体验）
        this.$nextTick(() => {
          document.querySelector(".live-iframe-container").scrollIntoView({
            behavior: "smooth",
          });
        })
      })
    },
    /**
     * 关闭iframe，回到首页
     */
    closeLiveIframe() {
      this.showLiveIframe = false;
      this.currentLiveUrl = "";
      this.currentLiveTitle = "";
    },
    // 学习记录
    newsHistory() {
      let params = {
        page: this.page,
        limit: this.limit
      }
      newsHistory(params).then(res => {
        this.history = res.data.list
        this.total = res.data.page.total
      })
    },

  },
}
</script>

<style scoped lang="less">
// ================= 学习记录列表 =================
.record-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  .record-card {
    background-color: #fff;
    border-radius: 12px;
    box-sizing: border-box;
    padding: 15px;
    border: 1px solid #f1f1f1;

    .card-tag {
      ;
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 500;
      display: inline-block;
      float: left;

      &.tag-high {
        background-color: #fef2f2;
        color: #ef4444;
      }

      &.tag-middle {
        background-color: #fffbeb;
        color: #f59e0b;
      }

      &.tag-low {
        background-color: #eff6ff;
        color: #3a44f7;
      }
    }

    .card-content {
      display: flex;
      width: 100%;
      position: relative;

      .card-info {
        flex: 1;

        .name {
          font-size: 14px;
          font-weight: 500;
          color: #1e293b;
          margin: 15px 0;
          text-align: left;
        }

        .card-time {
          font-size: 12px;
          color: #94a3b8;
          margin-bottom: 15px;
          text-align: left;
        }

        .card-desc {
          font-size: 12px;
          color: #64748b;
          text-align: left;
        }
      }

      .card-cover {
        width: 80px;
        height: 80px;
        border-radius: 12px;
        position: absolute;
        top: -20px;
        right: 0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}

/* 🔥 新增：iframe 容器样式 */
.live-iframe-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  z-index: 9999;
  display: flex;
  flex-direction: column;


  .iframe-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #2f54eb;
    color: #fff;
    flex-shrink: 0;
    height: 56px;
    box-sizing: border-box;
  }

  .iframe-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
  }

  .close-btn {
    padding: 6px 12px;
    background: #fff;
    color: #2f54eb;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;
  }

  .close-btn:hover {
    background: #f0f0f0;
  }

  .live-iframe {
    width: 100%;
    flex: 1;
    border: none;
  }
}

/* 直播课卡片点击样式优化 */
.live-course-card {
  cursor: pointer;
  transition: all 0.3s;
}

.live-course-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
</style>
